import React, { useState } from 'react'
import { MyDatePicker }    from "../index";
import { Button }          from "reactstrap";
import { useForm }         from "react-hook-form";

const CloseInvestigation = ({changeInvestigationState}) => {

  const {register, handleSubmit} = useForm();

  const [closedOn, setClosedOn] = useState(new Date());
  return (
    <form className="row" onSubmit={handleSubmit(values => {
      changeInvestigationState({...values, closedOn})
    })}>
      <div className="col-5 border-bottom-gray toast-title-item">Closed On</div>
      <div className="col-7 mt-2 mb-2">
        <MyDatePicker
          dateFormat="MM/dd/yyyy"
          selected={closedOn}
          onChange={(value) => {
            setClosedOn(value);
          }}/>
      </div>
      <div className="col-5 border-bottom-gray toast-title-item">Outcome</div>
      <div className="col-7 mt-2 mb-2">
        <select className="form-control" name="outcome" ref={register}>
          <option value="">-</option>
          <option value="NotApplicable">NotApplicable</option>
          <option value="Substantiated">Substantiated</option>
          <option value="Poor Judgement">Poor Judgement</option>
          <option value="Unsubstantiated">Unsubstantiated</option>
        </select>
      </div>
      <div className="col-12 mt-4 mb-2"><Button>Close Investigation</Button></div>
    </form>
  )
};

export default CloseInvestigation